import { TrialOrderBy } from '@data/sdk/match';

export const TrialOrderByParams = {
  encode(value: any) {
    return value;
  },

  decode(strValue: any): TrialOrderBy | undefined {
    return strValue;
  },
};
